var _circle, _line, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#0070F3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.5,
    y1: 0.00999978,
    x2: 76.5,
    y2: 150.01,
    stroke: "#FF99DC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5938 99H30.0938L30.1562 94.0938H39.5938C42.8438 94.0938 45.5521 93.4167 47.7188 92.0625C49.8854 90.6875 51.5104 88.7708 52.5938 86.3125C53.6979 83.8333 54.25 80.9375 54.25 77.625V74.8438C54.25 72.2396 53.9375 69.9271 53.3125 67.9062C52.6875 65.8646 51.7708 64.1458 50.5625 62.75C49.3542 61.3333 47.875 60.2604 46.125 59.5312C44.3958 58.8021 42.4062 58.4375 40.1562 58.4375H29.9062V53.5H40.1562C43.1354 53.5 45.8542 54 48.3125 55C50.7708 55.9792 52.8854 57.4062 54.6562 59.2812C56.4479 61.1354 57.8229 63.3854 58.7812 66.0312C59.7396 68.6562 60.2188 71.6146 60.2188 74.9062V77.625C60.2188 80.9167 59.7396 83.8854 58.7812 86.5312C57.8229 89.1562 56.4375 91.3958 54.625 93.25C52.8333 95.1042 50.6667 96.5312 48.125 97.5312C45.6042 98.5104 42.7604 99 39.5938 99ZM33.3125 53.5V99H27.2812V53.5H33.3125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 73.0625V77.9688H97.375V73.0625H122ZM98.3125 53.5V99H92.2812V53.5H98.3125ZM127.25 53.5V99H121.25V53.5H127.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a64fddecfb37f91085d5a90708e963ae.svg";
export { ForwardRef as ReactComponent };